<template>
  <tr :class="rowRowClass">
    <td
      class="issue-cell"
      :style="{ paddingLeft: `${(row.level || 0) * 16}px` }"
    >
      <div class="issue-content">
        <button
          v-if="showExpand"
          class="expand-btn"
          @click="onToggle"
          :disabled="loading"
        >
          <a-icon :type="iconType" :rotate="iconRotate" />
        </button>
        <span v-if="row.isGroup" class="caret" />
        <div class="text-container">
          <span class="issue-text">{{ row.label }}</span>
          <span v-if="row.meta" class="meta">{{ row.meta }}</span>
        </div>
      </div>
    </td>

    <td class="sum-cell">{{ formatHour(row.total) }}</td>

    <td
      v-for="day in dayColumns"
      :key="`${row.id}-${day.date}`"
      class="log-cell"
    >
      <div v-if="row.values && row.values[day.date]" class="log-value">
        <span class="hours">
          {{ formatHour(row.values[day.date]) }}
        </span>

        <LogworkHourBar
          :hours="isShowHour ? row.values[day.date] : 0"
          :viewMode="viewMode"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import LogworkHourBar from "./LogworkHourBar.vue";

export default {
  name: "LogworkRow",
  components: {
    LogworkHourBar
  },
  props: {
    row: { type: Object, required: true },
    dayColumns: { type: Array, required: true },
    itemType: { type: String, default: "summary" },
    showExpand: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    viewMode: { type: String, default: 'day' },
    isShowHour: { type: Boolean, default: true },
    expandTrigger: Number
  },
  computed: {
    rowRowClass() {
      return {
        "group-row": this.row.isGroup,
        "level-1": this.row.level === 1,
        "child-row": this.row.isChild
      };
    },
    iconType() {
      return this.loading ? "loading" : "caret-right";
    },
    iconRotate() {
      return this.expanded ? 90 : 0;
    }
  },
  methods: {
    formatHour(value) {
      if (!value) return 0;
      return Number(value.toFixed(1))
        .toString()
        .replace(/\.0$/, "");
    },
    onToggle() {
      this.$emit("toggle-expand", this.row);
    }
  },
  watch: {
    
    expandTrigger() {
      console.log('trigger', this.row);

      if (!this.expanded && this.showExpand && !this.loading) {
        this.onToggle();
      }
    }
  }
};
</script>

<style scoped>
.group-row {
  background-color: #e6f7ff; /* Light blue background for groups */
  font-weight: 600;
}

.issue-cell {
  padding: 0 16px;
  border-right: 1px solid #f0f0f0;
  vertical-align: middle;
  font-size: 13px;
  color: #262626;
  max-width: 100px;
}

.issue-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.expand-btn {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 8px;
  padding: 0;
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ff4d4f; /* Red/Pink color for icon */
}

/* Target the Ant Design icon specifically if needed, or let it inherit color */
.expand-btn .anticon {
  color: #ff4d4f;
  font-size: 14px; /* Adjust size if needed */
}

.caret {
  color: #ff4d4f;
  border-top-color: #ff4d4f;
}

.expand-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.text-container {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.issue-text {
  white-space: normal;
  word-break: break-word;
  text-align: left;
}

.meta {
  font-size: 0.85em;
  color: #8c8c8c;
  margin-top: 2px;
}

.sum-cell {
  text-align: center;
  font-weight: 600;
  color: #262626;
  border-right: 1px solid #f0f0f0;
  vertical-align: middle;
  font-size: 13px;
  width: 50px;
}

.log-cell {
  border-right: 1px solid #f0f0f0;
  vertical-align: middle;
  padding: 0;
  height: 52px;
  width: 52px; /* Adjust based on design */
  position: relative;
}

.log-value {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.hours {
  font-size: 13px;
  color: #262626;
  z-index: 1;
}
</style>
